import React from "react";
import "./CertificateGroupingGWPGeneral.scss";
import CertificateGroupingListGWPGeneral from "../../features/CertificateGroupingListGWPGeneral/CertificateGroupingListGWPGeneral";

const CertificateGroupingGWPGeneral = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPGeneral />
    </div>
  );
};

export default CertificateGroupingGWPGeneral;
